import ZJApp from "../../../../app";

let utils = ZJApp.ZJUtils;
let ZJApi = ZJApp.ZJApis.ZJApi;

const info = {
    service: 'UniformAuthService',
    controller: 'OrgInfo'
}
const methods = [
    'AddItem',
    'UpdateItem',
    'DelItem',
    'GetItemById',
    'FindByConditions',
    'GetPageContentByConditions',
    'GetAllItems',
    'GetOrgTiers',
    'GetOrgContacts',
    'AddItemAndProductList',
    'UpdateItemAndProductList'
]

const factory = (Fun)=>{
    utils.extend(Fun.prototype, info)
    methods.forEach(path => {
        Fun.prototype[path] = function(data) {
            return this.post(path, data)
        }
    })
}

const OrgApi = ZJApi.defineNewApi('OrgApi', factory)

export default OrgApi